export default "__VITE_ASSET__a51c1eb6__"